import React from 'react'
import { Route, Redirect } from 'react-router-dom'
import Cookie from 'js-cookie'

export const ProtectedRoute = ({ component: Component, ...rest }) => {
    return <Route
        {...rest}
        render={props => {
            if (!!Cookie.get('onliveAdminId')) {
                return <Component {...props} />
            } else {
                return <Redirect to="/login" />
            }
        }}
    />
}